import { combineReducers } from "redux";
import authReducer from "./auth/authReducer";
import approvalsReducer from "./approvals/approvalsReducer";
import notificationReducer from "./notification/notificationReducer";
import approvalDetailsReducer from "./approvalDetails/approvalDetailsReducer";
import profileReducer from "./profile/profileReducer";
import realTimeDataReducer from "./realTimeData/reducer";
import { authTypes } from "./auth/authTypes";

const rootReducer = combineReducers({
  authReducer,
  approvalsReducer,
  notificationReducer,
  approvalDetailsReducer,
  profileReducer,
  realTimeDataReducer,
});

const resetEnhancer = (_rootReducer: typeof rootReducer) => (state: any, action: any) => {
  if (action.type !== authTypes.LOGOUT) return _rootReducer(state, action);

  return _rootReducer(undefined, action);
};

export default resetEnhancer(rootReducer);
